export default (width) => {
  switch (true) {
    case (width > 1600):
      return 30
    case (width > 1365):
      return 22
    case (width > 1024):
      return 15
    case (width > 768):
      return 5
    case (width > 525):
      return -1
    case (width > 400):
      return -4
    case (width >= 320):
      return -6
    default: return 30
  }
}



// WEBPACK FOOTER //
// ./src/utils/calculateGridRowHeight.js